import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-section',
  templateUrl: './shop-section.component.html',
  styleUrls: ['./shop-section.component.scss']
})
export class ShopSectionComponent implements OnInit {
  cardData = [
    {
      image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602247287/Rectangle_14_rgexyk.png',
      title: 'Home'
    },
    {
      image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602247288/Rectangle_12_fh5rta.png',
      title: 'Office'
    },
    {
      image: 'https://res.cloudinary.com/dfqkwnen0/image/upload/v1602247288/Rectangle_13_v0qq3o.png',
      title: 'Hotel'
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
